<template>
    <!-- begin:: Header Topbar -->
    <div class="topbar">
        <!--begin: Notifications -->
        <!-- <b-dropdown
      size="sm"
      variant="link"
      toggle-class="topbar-item text-decoration-none"
      no-caret
      right
      no-flip
    >
      <template v-slot:button-content>
        <div
          class="btn btn-icon btn-clean btn-dropdown btn-lg mr-1 pulse pulse-primary"
        >
          <span class="svg-icon svg-icon-xl svg-icon-primary">
            <inline-svg src="media/svg/icons/Code/Compiling.svg" />
          </span>
          <span class="pulse-ring"></span>
        </div>
      </template>
      <b-dropdown-text tag="div" class="min-w-md-350px">
        <form>
          <KTDropdownNotification></KTDropdownNotification>
        </form>
      </b-dropdown-text>
    </b-dropdown> -->
        <!--end: Notifications -->

        <!--begin: Language bar -->
        <!-- <div class="topbar-item">
      <b-dropdown
        size="sm"
        variant="link"
        toggle-class="btn btn-icon btn-clean btn-dropdown btn-lg mr-1 text-decoration-none"
        no-caret
        right
        no-flip
      >
        <template v-slot:button-content>
          <img
            class="h-20px w-20px rounded-sm"
            :src="languageFlag || getLanguageFlag"
            alt=""
          />
        </template>
        <b-dropdown-text tag="div" class="min-w-md-175px">
          <KTDropdownLanguage
            v-on:language-changed="onLanguageChanged"
          ></KTDropdownLanguage>
        </b-dropdown-text>
      </b-dropdown>
    </div> -->
        <!--end: Language bar -->

        <!-- <div class="topbar-item">
      <b-dropdown
        size="sm"
        variant="link"
        toggle-class="btn btn-icon btn-clean btn-dropdown btn-lg mr-1 text-decoration-none bell-btn"
        no-caret
        right
        no-flip
      >
        <template v-slot:button-content>
          <i class="la la-bell-o"></i>
        </template>
      </b-dropdown>
    </div>
    <div class="separator"></div> -->
        <!--begin: User Bar -->
        <DropdownUser />
        <!--end: User Bar -->
    </div>
    <!-- end:: Header Topbar -->
</template>

<style lang="scss">
.topbar {
    align-items: center;
    .dropdown-toggle {
        padding: 0;
        &:hover {
            text-decoration: none;
        }

        &.dropdown-toggle-no-caret {
            &:after {
                content: none;
            }
        }
    }

    .dropdown-menu {
        margin: 0;
        padding: 0;
        outline: none;
        .b-dropdown-text {
            padding: 0;
        }
    }

    .separator {
        height: 36px;
        width: 0.5px;
        background: #7c98b6;
        margin: 0 10px 0 10px;
    }
}
.bell-btn {
    margin-right: 0 !important;
}
.bell-btn i {
    color: #7c98b6 !important;
    font-size: 20px !important;
}
</style>

<script>
// import KTDropdownNotification from "@/view/layout/extras/dropdown/DropdownNotification.vue";
// import KTDropdownLanguage from "@/view/layout/extras/dropdown/DropdownLanguage.vue";
import DropdownUser from "@/view/layout/extras/dropdown/DropdownUser.vue";
import i18nService from "@/core/services/i18n.service.js";

export default {
    name: "KTTopbar",
    data() {
        return {
            languageFlag: "",
            languages: i18nService.languages,
        };
    },
    components: {
        DropdownUser,
    },
    methods: {
        onLanguageChanged() {
            this.languageFlag = this.languages.find((val) => {
                return val.lang === i18nService.getActiveLanguage();
            }).flag;
        },
    },
    computed: {
        getLanguageFlag() {
            return this.onLanguageChanged();
        },
    },
};
</script>
